/**
 * @generated SignedSource<<4288983225dfd2a0ed586e2aac6196a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupTableBody_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_FirstGroupRow_rankField">;
  readonly " $fragmentType": "groupTableBody_nativeIssueTable_rankField";
};
export type groupTableBody_nativeIssueTable_rankField$key = {
  readonly " $data"?: groupTableBody_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupTableBody_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "FragmentSpread",
      "name": "groupRow_issueTableGrouping_FirstGroupRow_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "420d521f2c1d7fd186bf816afc978766";

export default node;
